import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/app/providers/storeProvider/store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
